var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAugmenterLumiere(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 86.692 66.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 954",
    d: "M86.692 66.001h-15v-4h11V41.495a31.108 31.108 0 0 0-2.812-12.808c-2.153-4.417-5.279-7.109-9.293-8l.868-3.9a16.1 16.1 0 0 1 7.367 3.8 20.616 20.616 0 0 1 4.653 6.352 31.119 31.119 0 0 1 2.446 7.364 38.338 38.338 0 0 1 .771 7.162v24.536Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 955",
    d: "M68.531-.001a10.439 10.439 0 0 1 7.213 2.876l.04.039a10.268 10.268 0 0 1 0 14.5l-2.422 2.422a2.159 2.159 0 0 0-.538 1.993 22.815 22.815 0 0 1-5.843 21.863l-1.414 1.427-32.03-32.026 1.43-1.414a22.833 22.833 0 0 1 21.877-5.844l.02.005a2.082 2.082 0 0 0 .551.074 2.1 2.1 0 0 0 1.488-.615l.008-.008 2.41-2.41a10.439 10.439 0 0 1 7.21-2.882Zm4.44 5.759a6.481 6.481 0 0 0-8.881 0l-2.349 2.35a6.129 6.129 0 0 1-4.326 1.8 6.083 6.083 0 0 1-1.6-.214 18.84 18.84 0 0 0-16.533 3.482l26.19 26.186a18.9 18.9 0 0 0 3.481-16.529l-.007-.028a6.145 6.145 0 0 1 1.557-5.768l.02-.02 2.431-2.431a6.279 6.279 0 0 0 .017-8.827Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 956",
    d: "M43.813 57.446 0 57.031l45.862-38.3 14.549 14.551Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAugmenterLumiere);
export default __webpack_public_path__ + "static/media/augmenter-lumiere.f38ca0388b07d7f1c8859d50d3351e51.svg";
export { ForwardRef as ReactComponent };